function split() {
  var result = {};
  var regexParse = new RegExp('([a-z-0-9]{2,63}).([a-z.]{2,5})$');
  var urlParts = regexParse.exec(window.location.hostname);
  result.domain = urlParts[1];
  result.type = urlParts[2];
  result.subdomain = window.location.hostname
    .replace('www.', '')
    .replace(result.domain + '.' + result.type, '')
    .split('.')[0];
  return result;
}

function extractHostname(url) {
  const hostname = url.trim().replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '');
  return hostname;
}

function buildQuery(opt = {}) {
  let url = `?page=${opt.page || 1}`;

  if (opt.sort) {
    url += `&sort=${opt.sort}`;
  }
  if (opt.filter) {
    url += `&filter=${opt.filter}`;
  }
  if (opt.search) {
    url += `&q=${opt.search}`;
  }
  if (opt.id) {
    url += `&id=${opt.id}`;
  }

  return url;
}

function windowLocation() {
  return global.window && window.location;
}

module.exports = {
  split,
  windowLocation,
  extractHostname,
  buildQuery
};
